import styles from '../aside-styles.module.css';
import { NavLink } from 'react-router-dom';
import { ReactNode } from 'react';

interface AsideMenuProps {
    to?: string;
    children: ReactNode;
    onClick?: any;
}

const AsideMenuItem = ({ to, children, onClick }: AsideMenuProps) => {
    return (
        <NavLink to={to || ''} className={styles.subMenuItem} onClick={onClick}>
            <span className={styles.menuText}>{children}</span>
        </NavLink>
    );
};

export default AsideMenuItem;
